import { Button } from 'react-bootstrap';
import { useTranslation } from 'react-i18next';

export const ErrorPage = ({ error }) => {
  const { t } = useTranslation();
  return (
    <div className="not-found-container">
      <div className="not-found-content">
        <h2 className="xxl-text bold">{t('shared.errorPage.title')}</h2>
        <h3 className="xl-text bold">{t('shared.errorPage.subtitle')}</h3>
        <Button className='accent redirect-button bold large-text margin-top-1 no-border' href='/'>{t('common.backHome')}</Button>
      </div>
    </div>
  );
}
